import serviceData from '../redux/services/mock';
import { isTestEnvironment } from '../util/environment';

export default function () {
  if (isTestEnvironment()) {
    this.get('/api/v1/services', this.passthrough);
    this.post('/api/v1/services', this.passthrough);
    return;
  }

  this.get('/api/v1/services', () => [
    200,
    { 'Content-Type': 'application/json' },
    JSON.stringify(serviceData.WITH_NO_SERVICES)
  ]);

  this.post('/api/v1/services', ({ requestBody }) => {
    const serviceName = JSON.parse(requestBody).service.name;

    return [
      201,
      { 'Content-Type': 'application/json' },
      JSON.stringify(serviceData.POST_RESPONSE(serviceName))
    ];
  });
}
